import { createContext, useContext } from 'react';
import type { NavItemKey } from './SecondaryNav';

type SecondaryNavContext = {
  selectedItemKey: NavItemKey | null;
  expandedSectionKeys: NavItemKey[];
  registerSelectedItemKey: (key: NavItemKey | null) => void;
  registerExpandedSectionKeys: (keys: NavItemKey[]) => void;
};

export const SecondaryNavContext = createContext<
  SecondaryNavContext | undefined
>(undefined);

export const useSecondaryNavContext = () => {
  const context = useContext(SecondaryNavContext);
  if (context === undefined) {
    throw new Error(
      'useSecondaryNavContext must be used within a SecondaryNavContext (which is available by using SecondaryNav)'
    );
  }
  return context;
};
